var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"c-contest-rules"},[_c('div',{staticClass:"block p-t-b"},[_c('main-image-section'),_c('dynamic-link',{attrs:{"type":_vm.tpl}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }